export const UNREAD_NOTIFICATION_COUNT = 'api/get-unread-notifications-count';
export const INPLAY_MATCHES_COUNT = 'v1/events/count';
export const GET_CASINO_GAMES='api/get-casino-games';
export const MATCHES_BY_SPORT_ID = 'v1/events/matches/';
export const GET_SPORTS= 'v1/sports/management/getSport';



